import React, { useEffect, useState } from 'react'

// components

import CardEditStore from 'components/Cards/CardEditStore.js'
import CardEditStoreParameters from 'components/Cards/CardEditStoreParameters.js'

export default function EditStore() {
    const [isAdmin, setIsAdmin] = useState(0)

    useEffect(() => {
        const cookieDataItem = localStorage.getItem(`robot-user-data`)
        if (!cookieDataItem) return
        const userData = JSON.parse(cookieDataItem)
        setIsAdmin(userData.role_id === 2)
    }, [])

    return (
        <>
            <div className="flex flex-wrap">
                <div className="w-full lg:w-8/12 px-4">
                    <CardEditStoreParameters />
                </div>
                <div className="w-full lg:w-4/12 px-4">{isAdmin ? <CardEditStore /> : ''}</div>
            </div>
        </>
    )
}
